<template>
  <div class="view pm tasks">
    <div class="page">
      <div class="header">
        <h4 class="text-black mt-2 mb-3">
          <strong> Personal Tasks ({{ user.display_name }})</strong>
        </h4>
      </div>
      <div>
        <div class="d-flex align-items-center mb-4">
          <div class="kit__utils__avatarGroup mr-4 flex-shrink-0">
            <div class="kit__utils__avatar kit__utils__avatar--size46 kit__utils__avatar--rounded">
              <img src="/resources/images/avatars/1.jpg" alt="Mary Stanform" />
            </div>
            <div class="kit__utils__avatar kit__utils__avatar--size46 kit__utils__avatar--rounded">
              <img src="/resources/images/avatars/2.jpg" alt="Mary Stanform" />
            </div>
            <div class="kit__utils__avatar kit__utils__avatar--size46 kit__utils__avatar--rounded">
              <img src="/resources/images/avatars/3.jpg" alt="Mary Stanform" />
            </div>
            <div class="kit__utils__avatar kit__utils__avatar--size46 kit__utils__avatar--rounded">
              <img src="/resources/images/avatars/4.jpg" alt="Mary Stanform" />
            </div>
            <button class="kit__utils__avatarGroupAdd">
              <i class="fe fe-plus"></i>
            </button>
          </div>
          <a class="mr-4" href="javascript: void(0);">Only My Tasks ({{ user.display_name }})</a>
          <div>Recently Updated</div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="card bg-light py-3 px-2">
              <h3 class="font-weight-bold text-dark font-size-18 mb-3">To Do</h3>
              <draggable :list="todo" group="tasks" style="min-height: 800px" :move="onMove" @change="onTodo">
                <div :class="$style.card" v-for="item in todo" :key="item._id">
                  <div :class="$style.content">
                    <div :class="[$style.flag, 'bg-' + item.color]"></div>
                    <div class="d-flex flex-wrap-reverse align-items-center">
                      <h5 class="text-dark font-size-18 mt-2 mr-auto">{{ item.name }}</h5>
                      <i class="fe-arrow-right-circle text-success font-size-30 flex-shrink-0 fe"></i>
                    </div>
                    <div class="text-gray-5 mb-2">Deadline {{ item.deadline | moment('lll') }}</div>
                    <div class="d-flex align-items-center flex-wrap pb-2">
                      <div class="d-flex align-items-center">
                        <div class="kit__utils__avatarGroup mr-2 flex-shrink-0">
                          <div
                            class="kit__utils__avatar kit__utils__avatar--size30 kit__utils__avatar--rounded"
                            v-for="participant in item.participants"
                            :key="participant._id"
                          >
                            <img :src="participant.avatar" :alt="participant.display_name" />
                          </div>
                        </div>
                      </div>

                      <div class="text-gray-5">
                        {{ item.description }}
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="card bg-light py-3 px-2">
              <h3 class="font-weight-bold text-dark font-size-18 mb-3">In Progress</h3>
              <draggable :list="progress" group="tasks" style="min-height: 800px" :move="onMove" @change="onProgress">
                <div :class="$style.card" v-for="item in progress" :key="item._id">
                  <div :class="$style.content">
                    <div :class="[$style.flag, 'bg-' + item.color]"></div>
                    <div class="d-flex flex-wrap-reverse align-items-center">
                      <h5 class="text-dark font-size-18 mt-2 mr-auto">{{ item.name }}</h5>
                      <i class="fe-arrow-right-circle text-success font-size-30 flex-shrink-0 fe"></i>
                    </div>
                    <div class="text-gray-5 mb-2">Deadline {{ item.deadline | moment('lll') }}</div>
                    <div class="d-flex align-items-center flex-wrap pb-2">
                      <div class="d-flex align-items-center">
                        <div class="kit__utils__avatarGroup mr-2 flex-shrink-0">
                          <div
                            class="kit__utils__avatar kit__utils__avatar--size30 kit__utils__avatar--rounded"
                            v-for="participant in item.participants"
                            :key="participant._id"
                          >
                            <img :src="participant.avatar" :alt="participant.display_name" />
                          </div>
                        </div>
                      </div>
                      <div class="text-gray-5">
                        {{ item.description }}
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="card bg-light py-3 px-2">
              <h3 class="font-weight-bold text-dark font-size-18 mb-3">Completed</h3>
              <draggable :list="completed" group="tasks" style="min-height: 800px" :move="onMove" @change="onCompleted">
                <div :class="$style.card" v-for="item in completed" :key="item._id">
                  <div :class="$style.content">
                    <div :class="[$style.flag, 'bg-' + item.color]"></div>
                    <div class="d-flex flex-wrap-reverse align-items-center">
                      <h5 class="text-dark font-size-18 mt-2 mr-auto">{{ item.name }}</h5>
                      <i class="fe-arrow-left-circle text-danger font-size-30 flex-shrink-0 fe"></i>
                    </div>
                    <div class="text-gray-5 mb-2">Deadline {{ item.deadline | moment('lll') }}</div>
                    <div class="d-flex align-items-center flex-wrap pb-2">
                      <div class="d-flex align-items-center">
                        <div class="kit__utils__avatarGroup mr-2 flex-shrink-0">
                          <div
                            class="kit__utils__avatar kit__utils__avatar--size30 kit__utils__avatar--rounded"
                            v-for="participant in item.participants"
                            :key="participant._id"
                          >
                            <img :src="participant.avatar" :alt="participant.display_name" />
                          </div>
                        </div>
                      </div>
                      <div class="text-gray-5">
                        <del>{{ item.description }}</del>
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

import store from '@/store'
import router from '@/router'

const KEY = 'tasks'

export default {
  components: {
    draggable,
  },
  // async beforeRouteEnter(to, from, next) {
  //   await store.dispatch('pm/fetchTasksByUser')
  //   next()
  // },
  data() {
    return {
      tasks: [],
      todo: [],
      progress: [],
      completed: [],
    }
  },
  methods: {
    async refresh() {
      this.$store.dispatch('pm/fetchTasksByUser')
      this.tasks = await store.getters['pm/data'](KEY)
      this.assignments()
    },

    onMove(e) {
      return true
    },

    async onTodo(e) {
      console.log(e)
      if (e && e.added && e.added.element) {
        const updateBody = e.added.element
        if (updateBody.progress !== 'todo') {
          updateBody.progress = 'todo'
          await this.$store.dispatch('pm/updateTask', updateBody)
          this.$message.success(`Task ${updateBody.name} has been updated successfully!`)
        }
      }
    },

    async onProgress(e) {
      console.log('onProgress', e)
      if (e && e.added && e.added.element) {
        const updateBody = e.added.element
        if (updateBody.progress !== 'in-progress') {
          updateBody.progress = 'in-progress'
          await this.$store.dispatch('pm/updateTask', updateBody)
          this.$message.success(`Task ${updateBody.name} has been updated successfully!`)
        }
      }
    },

    async onCompleted(e) {
      if (e && e.added && e.added.element) {
        const updateBody = e.added.element
        if (updateBody.progress !== 'completed') {
          updateBody.progress = 'completed'
          await this.$store.dispatch('pm/updateTask', updateBody)
          this.$message.success(`Task ${updateBody.name} has been updated successfully!`)
        }
      }
    },

    assignments() {
      this.todo = this.tasks
        ?.filter((t) => t.progress === 'todo')
        .map((task) => {
          return { color: 'danger', ...task }
        })

      this.progress = this.tasks
        ?.filter((t) => t.progress === 'in-progress')
        .map((task) => {
          return { color: 'primary', ...task }
        })

      this.completed = this.tasks
        ?.filter((t) => t.progress === 'completed')
        .map((task) => {
          return { color: 'success', ...task }
        })
    },
  },
  computed: {
    user: () => store.getters['user/user'],
    loading: () => store.getters['pm/loading'](KEY),
    pagination: () => store.getters['pm/pagination'](KEY),
    meta: () => store.getters['pm/meta'](KEY),
  },
  async mounted() {
    let a = await store.dispatch('pm/fetchTasksByUser')
    this.tasks = await store.getters['pm/data'](KEY)
    this.assignments()
  },
  destroyed() {
    // store.commit('pm/INIT')
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
.tasks {
  .list-row {
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
  }
}
</style>
